import { DynamicFormOptionConfig, OR_OPERATOR } from '@ng-dynamic-forms/core';
import { EVENT_TYPE_EDIT_KUNDE } from '../shared-models/custom-events.model';
import { SelectedKontaktTyp } from './kontakt-angabe.model';

export const BENACHRICHTIGUNG_KEINE = 'keine_benachrichtigung';

export const BENACHRICHTIGUNG_OPTIONEN: DynamicFormOptionConfig<string>[] = [
  {
    label: 'Keine Benachrichtigung gewünscht.',
    value: BENACHRICHTIGUNG_KEINE
  },
  {
    label: 'Benachrichtigung per SMS',
    value: SelectedKontaktTyp.Mobile
  },
  {
    label: 'Benachrichtigung per E-Mail',
    value: SelectedKontaktTyp.Email
  }
];

export const KONTAKT_TEMPLATE = [
  {
    id:            'EINSTIEG_FF_versicherungsnehmer',
    type:          'SELECT-EDIT',
    label:         'Versicherungsnehmer',
    required:      true,
    eventName:     EVENT_TYPE_EDIT_KUNDE,
    errorMessages: {
      required: '{{ label }} ist ein Pflichtfeld.'
    }
  },
  {
    id:            'info',
    type:          'INFO',
    content:       'Wie soll der Versicherungsnehmer über den Schaden informiert werden?',
    isInstruction: true,
    hidden:        true
  },
  {
    id:            'benachrichtigungskanal',
    label:         'Benachrichtigung',
    type:          'SELECT',
    required:      true,
    hidden:        true,
    options:       BENACHRICHTIGUNG_OPTIONEN,
    errorMessages: {
      required: '{{ label }} ist ein Pflichtfeld.'
    }
  },
  {
    id:            'mobile',
    type:          'SELECT',
    required:      true,
    hidden:        true,
    label:         'Telefonnummer',
    options:       [],
    errorMessages: {
      required: '{{ label }} ist ein Pflichtfeld.'
    },
    relations:     [
      {
        match: 'VISIBLE',
        when:  [
          {
            id:    'benachrichtigungskanal',
            value: SelectedKontaktTyp.Mobile
          }
        ]
      }
    ]
  },
  {
    id:            'email',
    type:          'SELECT',
    required:      true,
    hidden:        true,
    label:         'E-Mail Adresse',
    options:       [],
    errorMessages: {
      required: '{{ label }} ist ein Pflichtfeld.'
    },
    relations:     [
      {
        match: 'VISIBLE',
        when:  [
          {
            id:    'benachrichtigungskanal',
            value: SelectedKontaktTyp.Email
          }
        ]
      }
    ]
  },
  {
    id:            'infomobile',
    type:          'INFO',
    content:
                   'Der Versicherungsnehmer stimmt ausdrücklich zu, dass er über den gesamten Ablauf dieses Schadens per SMS/E-Mail informiert wird und die Möglichkeit erhält freiwillig Feedback zur Schadenabwicklung zu geben (Das Feedback wird bei Haftpflichtschäden nicht abgefragt).',
    isInstruction: false,
    hidden:        false,
    relations:     [
      {
        match:    'VISIBLE',
        operator: OR_OPERATOR,
        when:     [
          {
            id:    'benachrichtigungskanal',
            value: SelectedKontaktTyp.Mobile
          },
          {
            id:    'benachrichtigungskanal',
            value: SelectedKontaktTyp.Email
          }
        ]
      }
    ]
  }
];
